import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'app-crumb',
  templateUrl: './crumb.component.html',
  styleUrls: [ './crumb.component.scss' ],
  standalone: true
})
export class CrumbComponent {
  @Input() label: string;
  @Input() url: string;
  @HostBinding('class.fw-bold-last')
  @Input() bold = true;
}
